import {lazy} from 'react'

export const MikrotikTableLazy = lazy(() => import('./MikrotikTable'))
